import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStatusOverlay } from '@fs/zion-ui'
import Cookies from 'js-cookie'
import { i18n } from '@fs/zion-locale'
import useZionAxios from '../useZionAxios'
import useShowError from './useShowError'

export default function useResendEmailToken() {
  const { t } = useTranslation()
  return useResend({
    sentMessage: t('email-sent.alert', 'A code was sent to your email.'),
  })
}

function useResend({ sentMessage }) {
  const showStatusOverlay = useStatusOverlay()
  const showError = useShowError()

  const urlencoded = new URLSearchParams()
  urlencoded.append('_csrf', Cookies.get('XSRF-TOKEN'))

  const [{ response, error, loading }, resend] = useZionAxios(
    {
      url: `${window.location.origin}/login/ott/generate`,
      method: 'post',
      data: urlencoded,
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      xsrfCookieName: 'made-up-cookie-so-we-do-not-sent',
    },
    { manual: true, useCache: false }
  )

  useEffect(() => {
    if (error && !response) {
      const formattedMessage =
        error?.status === 429
          ? i18n.t('locked-account.validation', 'Your account has been locked temporarily. Please try again later.')
          : null
      showError(error, formattedMessage)
    }
  }, [error, response, showError])

  useEffect(() => {
    if (response?.status === 204) {
      showStatusOverlay({
        message: sentMessage,
        type: 'success',
      })
    }
  }, [response, sentMessage, showStatusOverlay])

  return { resend, loading }
}
